import { Component } from '@angular/core'

@Component({
    selector: 'project',
    template:require('./project.component.html'),
    styles:[require('./project.component.scss')]
})

export class ProjectComponent{
    
}